
<!--
 * @Author: Linpengze
 * @Date: 2022-06-06 20:07:24
 * @LAstEditors: Linpengze
 * @LastEditTime: 2022-06-06 20:07:24
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\CSDocumentManagement\resourceApply\index.vue
-->
<template>
    <div class="app-container">
        <div class="main">
            <div align="right" style="margin-right:10px;">
              <el-button @click.native="openConfigDialog" size="mini">查阅有效期设置</el-button>
            </div>
            <!-- 工具栏 -->
            <el-card class="filter-container" style="margin-top: -15px" shadow="never">
                <el-form
                        style="margin-left: -20px"
                        :model="listQuery"
                        size="small"
                        :inline="true"
                >
                    <el-row>
                        <el-col :span="18">
                            <el-input
                                    v-model="listQuery.keyWord"
                                    placeholder="输入关键词搜索,支持：昵称 / 姓氏 / 名字 / 单位 / 邮箱 / 手机号 "
                                    clearable
                                    @keyup.native.enter="onChangeProperty"
                            ><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
                        </el-col>
                        <el-col :span="6">
                            <el-select
                                    v-model="listQuery.auditStatus"
                                    placeholder="审核状态"
                                    style="margin-left: 10px;width:150px"
                                    clearable
                                    filterable
                                    @change="onChangeProperty"
                            >
                                <el-option
                                        v-for="(item,index) in statusOptions"
                                        :key="index"
                                        :label="item.label"
                                        :value="item.value" />
                            </el-select>
                            <el-button type="primary" size="medium" style="margin-left: 10px;border-radius: 2px;margin-top: 2px"  @click="search()">
                                {{ $t("search") }}
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>
            <!-- 表格 -->
            <el-table
                    v-loading="loading"
                    :data="applyList"
                    :header-cell-style="{ background: '#F5F7FA' }"
                    style="width: 100%; margin-bottom: 20px;margin-top: -20px"
                    stripe
                    border
            >
                <el-table-column
                        prop="recordID"
                        label="序号"
                        align="center"
                        width="70"
                ></el-table-column>
                <el-table-column
                        label="申请人昵称"
                        align="center"
                        width="150"
                >
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="left">
                            <p>昵称：{{ scope.row.userName }}</p>
                            <p>
                                姓名：{{scope.row.realName}}</p>
                            <p>手机：{{ scope.row.mobile }}</p>
                            <p>邮箱：{{ scope.row.email }}</p>
                            <p>单位：{{ scope.row.organization }}</p>
                            <div slot="reference" class="name-wrapper">
                                {{ scope.row.userName | ellipsis }}
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="applyDate"
                        label="申请查阅日期"
                        align="center"
                ></el-table-column>
                <el-table-column
                        prop="expireDate"
                        label="查阅有效期"
                        align="center"
                ></el-table-column>
                <el-table-column
                        prop="status"
                        label="审核状态"
                        align="center"
                >
                    <template slot-scope="scope">

                        <a style="color: blue">{{ scope.row.status === 0 ? "待审核" :scope.row.status === 1 ? "已通过": scope.row.status === 2?"已拒绝":"" }}</a>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="operation"
                        label="审核：通过/拒绝"
                        align="center"
                        width="250"
                >
                    <template slot-scope="scope">
                        <el-button
                                type="success"
                                size="small"
                                title="Agree user"
                                icon="el-icon-check"
                                :disabled="scope.row.status === 1"
                                @click="setEffectiveDays(scope.row)"
                        >
                        </el-button>
                        <el-button
                                type="danger"
                                size="small"
                                title="Disagree user"
                                icon="el-icon-close"
                                :disabled="scope.row.status === 2"
                                @click="reviewUserApplication(scope.row, 2)"
                        >
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div v-show="totalCount > pageSize" class="pagination">
                <el-pagination
                        v-show="applyList.length > 0"
                        background
                        layout="prev, pager, next"
                        :page-size="pageSize"
                        :total="totalCount"
                        :current-page="currentPage"
                        @current-change="currentChange"
                />
            </div>
            <p style="color: dimgrey;">共{{totalCount}}条</p>


            <!-- 设置有效时长 -->
            <el-dialog
                    title="审核通过：允许用户查阅文档资源"
                    :visible.sync="setEffectiveDaysDialog"
                    width="25%"
            >
                <el-form :model="activeUserApplication">
                    <el-form-item label="续期" label-width="100px">
                        <el-select
                                v-model="activeUserApplication.effectiveDays"
                                style="width: 100%"
                        >
                            <el-option label="一天" :value="1"> </el-option>
                            <el-option label="三天" :value="3"> </el-option>
                            <el-option label="一周" :value="7"> </el-option>
                            <el-option label="一个月" :value="30"> </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer">
                    <el-button size="small" @click="setEffectiveDaysDialog = false">
                        取消
                    </el-button>
                    <el-button
                            type="primary"
                            size="small"
                            @click="reviewUserApplication(activeUserApplication, 1)"
                    >
                        确认
                    </el-button>
                </div>
            </el-dialog>


            <el-dialog title="全局配置" :visible.sync="csConfigDialog" width="30%">
                <el-form :model="csDefaultAccessHours">
                    <el-form-item label="默认查阅文档期限（单位：小时）">
                        <el-input
                                placeholder="请输入"
                                v-model="csDefaultAccessHours"
                                maxlength="5"
                                style="width:80px"
                                @keyup.native="changeCsDefaultAccessHours(csDefaultAccessHours)"
                        >
                        </el-input>
                        <span style="line-height:2em;color: gray" > 约{{csDefaultAccessDays}}天</span>
                    </el-form-item>
                </el-form>
                <p style="line-height:2em;color: gray" ><i class="el-icon-warning-outline" style="color: red"></i>终端用户首次绑定设备型号后，系统自动为用户配置<a style="color: blue">默认查阅文档期限，到期后需重新申请续期</a></p>
                <div slot="footer">
                    <el-button size="small" @click="csConfigDialog=false">
                        取消
                    </el-button>
                    <el-button type="primary" size="small" @click="updateCsConfig()">
                        确认
                    </el-button>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
import {
    csFileReadRequestAudit,
    csFileReadRequestList,
    getCsConfig,
    CsConfigUpdate
} from "@/api/system/CSDocument/file";

import {
    reviewUserApplication,
} from "@/api/system/CSDocument/user";
import {userBindRole} from "../../../../api/role";

export default {
    data() {
        return {
            setEffectiveDaysDialog: false, // 设置有效时长对话框
            activeUserApplication: {}, // 当前选中申请对象
            listQuery:{
                keyWord:"",
                auditStatus:'',
            },
            labelWidth:"100px",
            loading: false, // 加载开关
            applyList:[],
            totalCount: 0, // 总数
            currentPage: 1, // 当前页码
            pageSize: 10, // 每页条数
            statusOptions: [
                {
                    value: 0,
                    label: '待审核'
                }, {
                    value: 1,
                    label: '已通过'
                }, {
                    value: 2,
                    label: '已拒绝'
                }
            ],
            csDefaultAccessHours:'',
            csConfigDialog:false,
            csDefaultAccessDays:'',
        };
    },
    created() {
        this.getList();
    },


    filters: {
        ellipsis(value) {
            if (!value) return "";
            if (value.length > 9) {  // 设置字符超过20个后使用...
                return value.slice(0, 8) + "...";
            }
            return value;
        }
    },
    methods: {
        onChangeProperty(){
            this.currentPage=1; // 当前页码
            this.pageSize=10; // 每页条数
            this.getList();
        },

        currentChange(currentPage){
            this.currentPage = currentPage;
            this.getList();
        },

        /**
         * 设置有效时长
         *
         * @param {object} row 选中对象
         */
        setEffectiveDays(row) {
            this.setEffectiveDaysDialog = true;
            this.activeUserApplication = row;
            this.$set(this.activeUserApplication, "effectiveDays", 1);
        },

        /**
         * 更改用户申请状态
         *
         * @param {object} row 选中对象
         * @param {number} status 状态
         */
        reviewUserApplication(row, status) {
            this.setEffectiveDaysDialog = false;
            const data = {
                csFileReadReqID: row.recordID,
                status: status,
                effectiveDays: status === 1 ? row.effectiveDays : 1,
            };
            if(status !== 1){
                let tips = "您确定要拒绝/关闭用户访问文档续期申请吗？";
                this.$confirm(tips, this.$t("tips"), {
                    confirmButtonText: this.$t("yes"),
                    cancelButtonText: this.$t("no"),
                    type: "warning",
                })
                    .then(() => {
                        csFileReadRequestAudit(data).then((res) => {
                            this.$notify({
                                title: '操作成功',
                                message: "已拒绝/关闭用户访问文档续期申请",
                                type: 'success'
                            });
                            this.getList();
                        });
                    });
            }
            else{
                csFileReadRequestAudit(data).then((res) => {
                    this.$notify({
                        title: '操作成功',
                        message: '已成功为用户访问文档续期',
                        type: 'success'
                    });
                    this.getList();
                });
            }
        },

        reset(){
          this.listQuery.keyWord="";
          this.listQuery.auditStatus='';
          this.currentPage=1;
          this.getList();
        },
        search(){
            this.getList();
        },

        getList(){
            let params={
                keyWord:this.listQuery.keyWord,
                pageNumber:this.currentPage,
                pageSize:this.pageSize,
                sortName:"",
                sortOrder:"",
            };
            if(this.listQuery.auditStatus!==''){
                params.where=[];
                params.where.push({"field":"auditStatus","value":this.listQuery.auditStatus.toString(),"op":"equal"});
            }
            this.loading = true;
            csFileReadRequestList(params).then((res) => {
                this.applyList=[];
                if(res.data.rows!==[]){
                    for(const row of res.data.rows){
                        this.applyList.push({
                            recordID:row.csFileReadReqID,
                            email:(row.loginEmail===""||row.loginEmail===null)?"-":row.loginEmail,
                            mobile:row.mobilePhone===""?"-":row.mobilePhone,
                            userName:row.nickname===""?"-":row.nickname,
                            organization:(row.organization===""||row.organization===null)?"-":row.organization,
                            applyDate:row.createTime!==""?row.createTime.split(' ')[0]:"-",
                            expireDate:row.auditStatus===1?row.auditTime.split(' ')[0]+" - "+row.expirationTime.split(' ')[0]:"-",
                            status:row.auditStatus,
                            realName:(row.firstName!==null&&row.lastName!==null)?(row.firstName+row.lastName):(row.firstName!==null?row.firstName:(row.lastName!==null?row.lastName!==null:"-"))
                        })
                    }
                }
                this.totalCount = res.data.total;
                this.utils.stopLoading(this);
            });

        },

        formatDate(date){
            console.log(date);
            let newDate = new Date(date);
            let year = newDate.getFullYear();
            let month = (newDate.getMonth()).toString().padStart(2,0);
            let day = (newDate.getDay()).toString().padStart(2,0);
            console.log(newDate);
            console.log(year+"-"+month+"-"+day)
            return year + '-' + month + '-' + day;

        },

        handleCommand(command){
            switch (command.command) {
                case 1:
                    console.log(1);
                    console.log(command.index);
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    break;
                case 2:
                    console.log(2);
                    console.log(command.index);
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    break;
            }
        },

        /*********************以下是访问期限配置*****************************/
        openConfigDialog() {
            return new Promise((resolve, reject) => {
                getCsConfig().then((res) => {
                    if (res.code === 200) {
                        if (res.data !== null && res.data !== {}) {
                            this.csDefaultAccessHours = res.data.csDefaultAccessHours;
                            if(this.csDefaultAccessHours!==null){
                                this.csDefaultAccessDays=Math.round(this.csDefaultAccessHours/24);
                            }
                            this.csConfigDialog = true;

                        }
                    }
                });
            });
        },
        changeCsDefaultAccessHours(e){
            console.log(e);
            if(e==null){
                this.csDefaultAccessDays=0;
            }
            else{
                this.csDefaultAccessDays=Math.round(e/24);
            }
        },
        updateCsConfig(){
            if(this.csDefaultAccessHours!==null){
                let param={
                    csDefaultAccessHours:parseInt(this.csDefaultAccessHours),
                };
                CsConfigUpdate(param).then((res) => {
                    if (res.code === 200) {
                        this.$message({
                            message: "修改成功！",
                            type: "success",
                        });
                        this.csConfigDialog=false;
                    }
                });
            }
        }
        /*********************以上是访问期限配置*****************************/
    }
};
</script>
<style lang="scss" scoped>
    .el-dropdown-link {
        cursor: pointer;
    }

    .el-icon-s-operation {
        font-size: 24px;
    }
    .el-card{
        padding: 0px 0px;
        border: none;
    }
</style>